import React from "react";
import ReactPaginate from "react-paginate";
import Loading from "../../../components/loading";

export default function ListItems({
    loading,
    filteredItems,
    selected,
    handleSelect,
    handleToggleStatus,
    uoms,
    pageCount,
    handlePageClick,
}) {
    return (
        <div className="table-responsive">
            <table className="table table-striped table-bordered mb-0">
                <thead className="table-light">
                    <tr>
                        <th>Select</th>
                        <th>Item Category</th>
                        <th>Item Name</th>
                        <th>Description</th>
                        <th>UOM</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="6" className="text-center py-4">
                                <Loading />
                            </td>
                        </tr>
                    ) : filteredItems.length > 0 ? (
                        filteredItems.map((item) => {
                            const isActive =
                                item.status === "Active" ||
                                item.status === 1 ||
                                item.status === true;

                            return (
                                <tr key={item.id}>
                                    <td>
                                        <input
                                            type="radio"
                                            name="itemSelect"
                                            disabled={item.status === "Inactive"}
                                            checked={selected === item.id}
                                            onChange={() => handleSelect(item.id)}
                                        />
                                    </td>
                                    <td>{item.itemCategoryName || "-"}</td>
                                    <td>{item.itemCode}</td>
                                    {/* <td>{item.itemName}</td> */}
                                    
                                    <td>{item.itemDescription || "-"}</td>
                                    <td>
                                        {uoms.find((u) => u.id === item.uomId)?.uomCode || "-"}
                                    </td>
                                    <td>
                                        <span
                                            className={`badge ${isActive ? "bg-success" : "bg-secondary"
                                                }`}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleToggleStatus(item)}
                                        >
                                            {isActive ? "Active" : "Inactive"}
                                        </span>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="6" className="text-center text-muted">
                                No items found
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <ReactPaginate
                breakLabel="..."
                nextLabel="Next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="< Previous"
                containerClassName="pagination-container"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
            />
        </div>
    );
}
